export default __webpack_public_path__ + "static/media/discord.864abbe5.svg";